import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import '../../../fontawesome.jsx';
import { toCamelCase } from './side-nav-utils';

const StartIcon = ({ depth, icon }) => (
  depth === 0 ? (
    <FontAwesomeIcon icon={`fa-regular ${icon}`} />
  ) : (
    <Box
      sx={{
        alignItems: 'center',
        display: 'center',
        height: 20,
        justifyContent: 'center',
        width: 20,
      }}
    >
      <FontAwesomeIcon icon={`fa-regular ${icon}`} />
    </Box>
  )
);

/** Icon + translated title, shared by branch and leaf items. */
export const NavItemLabel = ({ depth, icon, active, disabled, title }) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        component="span"
        sx={{
          alignItems: 'center',
          color: 'var(--nav-item-icon-color)',
          display: 'inline-flex',
          justifyContent: 'center',
          mr: 2,
          ...(active && {
            color: 'var(--nav-item-icon-active-color)',
          }),
        }}
      >
        <StartIcon depth={depth} icon={icon}/>
      </Box>

      <Box
        component="span"
        sx={{
          color: 'var(--nav-item-color)',
          flexGrow: 1,
          fontFamily: (theme) => theme.typography.fontFamily,
          fontSize: depth > 0 ? 13 : 14,
          fontWeight: depth > 0 ? 500 : 600,
          lineHeight: '24px',
          whiteSpace: 'nowrap',
          ...(active && {
            color: 'var(--nav-item-active-color)',
          }),
          ...(disabled && {
            color: 'var(--nav-item-disabled-color)',
          }),
        }}
      >
        {t(`admin.${toCamelCase(title)}`)}
      </Box>
    </>
  );
};

StartIcon.propTypes = {
  depth: PropTypes.number,
  icon: PropTypes.string,
};

NavItemLabel.propTypes = {
  depth: PropTypes.number,
  icon: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
};
